import { login, logout, getInfo } from "@/api/login";
import { checkteDept } from "@/api/auth";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { roleMap } from "@/utils/roleMap";

const user = {
  state: {
    token: getToken(),
    id: "",
    name: "",
    avatar: "",
    deptId: "",
    userDeptId: "",
    roles: [],
    permissions: [],
    currentProjectRelevantPeople: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_DEPTID: (state, deptId) => {
      state.deptId = deptId;
    },
    SET_USERDEPTID: (state, userDeptId) => {
      state.userDeptId = userDeptId;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_CURRENTPROJECTRELEVANTPEOPLE: (state, relevantPeople) => {
      state.currentProjectRelevantPeople = relevantPeople;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then((res) => {
            setToken(res.data.token);
            commit("SET_TOKEN", res.data.token);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = { deptId: null };
        if (sessionStorage.getItem("deptId")) {
          params.deptId = Number(sessionStorage.getItem("deptId"));
        }
        getInfo(params)
          .then((res) => {
            const user = res.data;
            const avatar =
              user.avatar == "" || user.avatar == null
                ? require("@/assets/touxiang.webp")
                : process.env.VUE_APP_BASE_API + user.avatar;
            if (res.data.roles && res.data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit("SET_ROLES", res.data.roles);
              commit("SET_PERMISSIONS", res.data.perms);
            } else {
              commit("SET_ROLES", ["ROLE_DEFAULT"]);
            }
            commit("SET_ID", user.userId);
            commit("SET_NAME", user.userName);
            commit("SET_AVATAR", avatar);

            if (sessionStorage.getItem("deptId")) {
              commit("SET_DEPTID", Number(sessionStorage.getItem("deptId")));
              checkteDept(Number(sessionStorage.getItem("deptId"))).then(
                (res) => {
                  if (res.data.roleId) {
                    commit("SET_ROLES", [roleMap[res.data.roleId]]);
                  }
                  // location.reload();
                  // this.$store.commit('SET_DEPTID', this.diptListId)
                  this.$store.dispatch("GenerateRoutes");
                  // this.CLOSE_ALL_TAGAS({})
                }
              );
            } else {
              if (user.deptId) {
                sessionStorage.setItem("deptId", user.deptId);
                commit("SET_DEPTID", user.deptId);
              }
            }
            if (user.userDeptId) {
              sessionStorage.setItem("userDeptId", user.userDeptId);
              commit("SET_USERDEPTID", user.userDeptId);
            }
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_PERMISSIONS", []);
        removeToken();
        resolve();
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },
  },
};

export default user;
